import { zfUtils } from "./zf_utils";
export class zfcmap {
    static infoBubbleConfig(place, addressData, map, currMap, otherMarker) {
        return {
            map: map,
            content: zfcmap.infoBubbleContent(place, addressData, currMap, otherMarker),
            padding: 0,
            backgroundColor: "#fff",
            borderRadius: 0,
            arrowSize: 10,
            borderWidth: 0,
            disableAutoPan: true,
            hideCloseButton: true,
            arrowPosition: 30,
            backgroundClassName: "zfcmap-map-tooltip-dialog",
            arrowStyle: 0,
        };
    }
    static infoBubbleHtml(currMap, otherMarker) {
        if (otherMarker != null) {
            var lineClass = "zfcmap-map-tooltip-content-address-line", url = "https://www.google.com/maps/place/" +
                otherMarker.name.replace(/ /g, "+") +
                "/@" +
                otherMarker.lat +
                "," +
                otherMarker.lng +
                ",15z", bubbleName = otherMarker.name
                ? '<a href="' +
                    url +
                    '" target="_blank" aria-label="(opens in a new tab)">' +
                    otherMarker.name +
                    "</a>"
                : "", bubbleLine1 = otherMarker.address1
                ? '<div class="' + lineClass + '">' + otherMarker.address1 + "</div>"
                : "", bubbleLine2 = otherMarker.address2
                ? '<div class="' + lineClass + '">' + otherMarker.address2 + "</div>"
                : "", bubbleLine3 = otherMarker.address3
                ? '<div class="' + lineClass + '">' + otherMarker.address3 + "</div>"
                : "";
        }
        return ('<div class="zfcui-prometo-medium zfcui-color-blue zfcui-hover-color-cyan-50 zfcui-active-color-blue zfcmap-map-tooltip-content-name">' +
            bubbleName +
            "</div>" +
            bubbleLine1 +
            bubbleLine2 +
            bubbleLine3);
    }
    static infoBubbleContent(place, addressData, currMap, otherMarker) {
        return ("" +
            '<div class="zfcmap-map-tooltip-content">' +
            '<div class="zfcmap-map-tooltip-content-address-container">' +
            zfcmap.infoBubbleHtml(currMap, otherMarker) +
            "</div>" +
            "</div>");
    }
    static setTooltip(currMap) {
        setTimeout(function () {
            currMap
                .find(".zfcmap-map-tooltip-dialog")
                .parent()
                .addClass("zfcmap-map-tooltip-wrapper")
                .next("div")
                .addClass("zfcmap-map-tooltip-arrow");
            currMap.find(".zfcmap-map-tooltip-wrapper").css("height", "250px");
            currMap.find(".zfcmap-map-photo").css("height", "400px");
        }, 500);
        setTimeout(function () {
            currMap.find(".zfcmap-map-photo").css("height", "401px");
        }, 1000);
    }
    static googleMapInit(currMap) {
        try {
            var position = {
                lat: currMap.data("otherMarkers")[0].lat,
                lng: currMap.data("otherMarkers")[0].lng,
            };
            var map = new zfcmap.google.maps.Map(currMap.find(".zfcmap-map-photo")[0], {
                center: position,
                zoom: currMap.data("otherMarkers").length == 1 ? 13 : 9,
                gestureHandling: "cooperative",
            });
            var marker = new zfcmap.google.maps.Marker({
                map: map,
                anchorPoint: new zfcmap.google.maps.Point(0, -29),
            });
            marker.setPosition(new zfcmap.google.maps.LatLng(currMap.data("otherMarkers")[0].lat, currMap.data("otherMarkers")[0].lng));
            const infoWindow = new zfcmap.google.maps.InfoWindow(zfcmap.infoBubbleConfig(null, null, map, currMap, currMap.data("otherMarkers")[0]));
            setTimeout(function () {
                infoWindow.open({ anchor: marker, map });
            }, 400);
            if (currMap.attr("data-other-markers") != null &&
                currMap.data("otherMarkers").length > 1) {
                currMap.data("otherMarkers").forEach(function (item, index) {
                    if (index == 0) {
                        return true;
                    }
                    var newMarker = new zfcmap.google.maps.Marker({
                        map: map,
                        anchorPoint: new zfcmap.google.maps.Point(0, -29),
                    });
                    newMarker.setPosition(new zfcmap.google.maps.LatLng(item.lat, item.lng));
                    var newInfoWindow = new zfcmap.google.maps.InfoWindow(zfcmap.infoBubbleConfig(null, null, map, currMap, item));
                    setTimeout(function () {
                        newInfoWindow.open({ anchor: newMarker, map });
                    }, 400);
                });
                let bounds = new zfcmap.google.maps.LatLngBounds();
                currMap.data("otherMarkers").forEach(function (item) {
                    bounds.extend(item);
                });
                map.fitBounds(bounds, { top: 150 });
            }
            currMap
                .find(".zfcmap-map-photo")
                .attr("data-location", currMap.data("otherMarkers")[0].name);
            return true;
        }
        catch (err) {
            console.log("Initalization failed: zfcmap.googleMapInit() " + err.message);
        }
    }
    static initItem(item) {
        try {
            var currMap = item;
            var result = zfcmap.googleMapInit(currMap);
            zfcmap.setTooltip(currMap);
            return result;
        }
        catch (err) {
            console.log("Initalization failed: zfcmap.initItem() " + err.message);
        }
    }
}
zfcmap.infoBubble = null;
zfcmap.map = null;
try {
    zfUtils.onReady(function () {
        zfcmap.addressBlock = $(".zfcmap-information-address .zfcmap-information-col-text");
        zfcmap.contactBlock = $(".zfcmap-information-contact .zfcmap-information-col-text");
        if ($(".zfcmap").length > 0) {
            $.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyCR4mR1W-vQWriogjLfxTdESZrEKpSGS-0&libraries=maps&callback=initMap").done(function () {
                zfcmap.google = globalThis["google"];
                $(".zfcmap").each(function () {
                    zfUtils.loadOnScroll($(this), "delayZFCMAPLoad", zfcmap.initItem, 1);
                });
            });
        }
    });
}
catch (err) {
    console.log("Initalization failed: zfcmap.init() " + err.message);
}
